export default "__VITE_ASSET__BfUTU6ES__"